import React from 'react';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment-timezone";

const cookies = new Cookies();

/* ============================================================
   صفحة الفهرس: قوائم المشتريات كبطاقات، مُصفَّحة من الخادم.

   الضغط على قائمة يفتحها في صفحة مستقلة (/purchaseList?id=..)،
   فتبقى هذه الصفحة خفيفة ومقروءة مهما كثرت القوائم.

   لماذا التصفيح من الخادم لا من المتصفّح:
   القائمة الواحدة قد تحمل ١٥٠٠ جهازاً وأكثر. جلب كل القوائم ثم
   تقطيعها هنا يعني أن الخادم حسب أعداد كل قائمة في الوجود لعرض
   اثنتي عشرة منها. الأعداد والملخّص كلها SUM في MySQL الآن، ولا
   جهاز واحد يصل المتصفّح.

   الملخّص الأعلى يأتي من الخادم لا من مجموع البطاقات المعروضة —
   وإلا صار «إجمالي الأجهزة» يتغيّر بتقليب الصفحات.
   ============================================================ */

const LIMITS = [12, 24, 48];

const S = {
  page: {
    padding: 28, direction: "rtl", background: "#f6f8fb", minHeight: "100vh",
    fontFamily: "'Segoe UI', Tahoma, sans-serif",
  },
  // حاوية بعرض أقصى: بلا هذا تتمدّد الجداول على الشاشات العريضة
  // فتتباعد الأعمدة ويصعب تتبّع الصف الواحد بالعين.
  // تُدمج في نمط الصفحة نفسها لتفادي تعديل بنية الـ JSX.
  // العرض الأقصى يُطبَّق عبر هوامش جانبية مرنة بدل maxWidth، كي تبقى
  // خلفية الصفحة ممتدة على كامل العرض بلا حواف رمادية.
  pageInner: {
    paddingInline: "max(24px, calc((100% - 1180px) / 2))",
    boxSizing: "border-box",
  },
  head: { marginBottom: 22 },
  h1: { fontSize: 26, fontWeight: 800, color: "#0f172a", margin: 0 },
  sub: { fontSize: 13.5, color: "#64748b", marginTop: 6 },

  statsRow: { display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 20 },
  stat: (accent) => ({
    flex: 1, minWidth: 165, padding: "17px 19px", background: "#fff",
    borderRadius: 15, border: "1px solid #eef2f7", borderTop: `3px solid ${accent}`,
    boxShadow: "0 1px 3px rgba(0,0,0,.05)",
  }),
  statLabel: { fontSize: 12.5, color: "#64748b", fontWeight: 600, marginBottom: 6 },
  statValue: (c) => ({ fontSize: 27, fontWeight: 800, color: c || "#0f172a", lineHeight: 1 }),
  statHint: { fontSize: 11.5, color: "#94a3b8", marginTop: 6 },

  // ===== شريط الأدوات =====
  toolbar: {
    display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center",
    background: "#fff", border: "1px solid #eef2f7", borderRadius: 14,
    padding: "12px 14px", marginBottom: 18, boxShadow: "0 1px 3px rgba(0,0,0,.04)",
  },
  searchWrap: { position: "relative", flex: 1, minWidth: 250 },
  searchInput: {
    width: "100%", boxSizing: "border-box", padding: "10px 38px 10px 34px",
    border: "1px solid #e2e8f0", borderRadius: 10, fontSize: 14,
    outline: "none", background: "#f8fafc", color: "#0f172a",
    fontFamily: "inherit", direction: "rtl",
  },
  searchIcon: {
    position: "absolute", insetInlineStart: 12, top: "50%", transform: "translateY(-50%)",
    fontSize: 14, color: "#94a3b8", pointerEvents: "none",
  },
  clearBtn: {
    position: "absolute", insetInlineEnd: 10, top: "50%", transform: "translateY(-50%)",
    border: "none", background: "#e2e8f0", color: "#475569", cursor: "pointer",
    width: 22, height: 22, borderRadius: "50%", fontSize: 13, lineHeight: "22px",
    padding: 0, fontFamily: "inherit",
  },
  tabs: { display: "flex", gap: 4, background: "#f1f5f9", padding: 4, borderRadius: 10 },
  tab: (on) => ({
    border: "none", cursor: "pointer", padding: "7px 15px", borderRadius: 8,
    fontSize: 13, fontWeight: 700, fontFamily: "inherit",
    background: on ? "#fff" : "transparent",
    color: on ? "#0f172a" : "#64748b",
    boxShadow: on ? "0 1px 3px rgba(0,0,0,.08)" : "none",
  }),
  select: {
    border: "1px solid #e2e8f0", borderRadius: 10, padding: "9px 10px",
    fontSize: 13, color: "#0f172a", background: "#f8fafc",
    fontFamily: "inherit", cursor: "pointer", outline: "none",
  },

  resultLine: {
    fontSize: 12.5, color: "#64748b", marginBottom: 12,
    display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap",
  },

  grid: {
    display: "grid", gap: 16,
    gridTemplateColumns: "repeat(auto-fill, minmax(310px, 1fr))",
  },
  card: (open) => ({
    background: "#fff", borderRadius: 16, padding: 20, cursor: "pointer",
    border: "1px solid " + (open ? "#bfdbfe" : "#eef2f7"),
    boxShadow: "0 1px 3px rgba(0,0,0,.06)", transition: ".18s",
    position: "relative", overflow: "hidden",
  }),
  cardStripe: (c) => ({
    position: "absolute", insetInlineStart: 0, top: 0, bottom: 0, width: 4, background: c,
  }),
  cardTop: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 },
  cardTitle: { fontSize: 18, fontWeight: 800, color: "#0f172a" },
  badge: (bg, color) => ({
    display: "inline-block", padding: "3px 11px", borderRadius: 20,
    fontSize: 11.5, fontWeight: 700, background: bg, color,
  }),

  // سطر التاجر — يُقصّ بالنقاط بدل أن يلفّ ويكسر ارتفاع البطاقة
  merchant: {
    fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 12,
    display: "flex", alignItems: "center", gap: 6,
    whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
  },
  merchantIcon: { fontSize: 12, color: "#94a3b8", fontWeight: 600, flexShrink: 0 },

  metaRow: { display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 14 },
  meta: { fontSize: 12.5, color: "#64748b" },
  metaVal: { fontSize: 15, fontWeight: 700, color: "#0f172a", marginTop: 2 },

  bar: { height: 7, borderRadius: 5, background: "#f1f5f9", overflow: "hidden", marginBottom: 9 },
  barFill: (pct, c) => ({ width: `${pct}%`, height: "100%", background: c, transition: ".3s" }),

  flags: { display: "flex", gap: 6, flexWrap: "wrap" },
  empty: { padding: 60, textAlign: "center", color: "#94a3b8", fontSize: 15, background: "#fff", borderRadius: 16 },

  // ===== التصفيح =====
  pager: {
    display: "flex", gap: 6, alignItems: "center", justifyContent: "center",
    flexWrap: "wrap", marginTop: 26, paddingBottom: 10,
  },
  pBtn: (off) => ({
    minWidth: 36, height: 36, padding: "0 10px", borderRadius: 9,
    border: "1px solid #e2e8f0", background: "#fff",
    color: off ? "#cbd5e1" : "#334155",
    fontSize: 13.5, fontWeight: 700, fontFamily: "inherit",
    cursor: off ? "default" : "pointer",
  }),
  pNum: (on) => ({
    minWidth: 36, height: 36, borderRadius: 9, fontSize: 13.5, fontWeight: 700,
    fontFamily: "inherit", cursor: on ? "default" : "pointer",
    border: "1px solid " + (on ? "#2563eb" : "#e2e8f0"),
    background: on ? "#2563eb" : "#fff",
    color: on ? "#fff" : "#334155",
  }),
  pDots: { color: "#94a3b8", padding: "0 4px", fontSize: 13 },
};

export default class PurchaseLists extends React.Component {
  constructor(props) {
    super(props);

    // القراءة من الرابط: مشاركة الرابط أو تحديث الصفحة يبقيان الحالة.
    const sp = new URLSearchParams(window.location.search);
    const limit = LIMITS.indexOf(Number(sp.get('limit'))) >= 0 ? Number(sp.get('limit')) : 12;
    const status = ['open', 'closed'].indexOf(sp.get('status')) >= 0 ? sp.get('status') : 'all';

    this.state = {
      lists: [],
      loading: true,
      page: Math.max(1, Number(sp.get('page')) || 1),
      limit,
      status,
      q: sp.get('q') || '',        // ما يكتبه المستخدم الآن
      qApplied: sp.get('q') || '', // ما أُرسل للخادم فعلاً
      totalItems: 0,
      totalpages: 1,
      totals: { lists: 0, open: 0, closed: 0, devices: 0, verified: 0, pending: 0, unpriced: 0, rejected: 0 },
    };

    // حارس السباق: الكتابة السريعة تُطلق نداءات متتابعة، والأبطأ قد يصل
    // أخيراً فيدهس نتيجة الأحدث. نتجاهل كل ردّ ليس آخر ما طُلب.
    this.reqId = 0;
    this.timer = null;
  }

  header() { return { "Content-Type": "application/json", token: cookies.get("token") }; }

  componentDidMount() { this.loadLists(); }

  componentWillUnmount() { if (this.timer) clearTimeout(this.timer); }

  syncUrl = () => {
    const { page, limit, status, qApplied } = this.state;
    const sp = new URLSearchParams();
    if (page > 1) sp.set('page', page);
    if (limit !== 12) sp.set('limit', limit);
    if (status !== 'all') sp.set('status', status);
    if (qApplied) sp.set('q', qApplied);
    const qs = sp.toString();
    window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
  };

  loadLists = () => {
    const { page, limit, status, qApplied } = this.state;
    const myId = ++this.reqId;

    this.setState({ loading: true });
    this.syncUrl();

    axios.get(host + 'purchase/lists', {
      headers: this.header(),
      params: { page: page, limit: limit, status: status, q: qApplied },
    })
      .then(res => {
        if (myId !== this.reqId) return;   // ردّ متأخّر لنداء قديم
        const d = (res.data && res.data.data) || {};
        this.setState({
          loading: false,
          lists: d.lists || [],
          totalItems: Number(d.totalItems) || 0,
          totalpages: Math.max(1, Number(d.totalpages) || 1),
          // الخادم يردّ رقم الصفحة بعد تقليمه للحدّ الأعلى، فلو حُذفت
          // قوائم وصار الرقم خارج المدى تصحّح الواجهة نفسها.
          page: Math.max(1, Number(d.page) || 1),
          totals: d.totals || this.state.totals,
        });
      })
      .catch(() => {
        if (myId !== this.reqId) return;
        this.setState({ loading: false });
        toast.error("تعذّر تحميل القوائم");
      });
  };

  // البحث مؤجّل: نداء لكل حرف يُغرق الخادم باستعلامات EXISTS على جدول
  // فيه عشرات الآلاف من الأجهزة.
  onSearchChange = (e) => {
    const q = e.target.value;
    this.setState({ q: q });
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.setState({ qApplied: q.trim(), page: 1 }, this.loadLists);
    }, 450);
  };

  onSearchKey = (e) => {
    if (e.key !== 'Enter') return;
    if (this.timer) clearTimeout(this.timer);
    this.setState({ qApplied: this.state.q.trim(), page: 1 }, this.loadLists);
  };

  clearSearch = () => {
    if (this.timer) clearTimeout(this.timer);
    this.setState({ q: '', qApplied: '', page: 1 }, this.loadLists);
  };

  setStatus = (status) => {
    if (status === this.state.status) return;
    this.setState({ status: status, page: 1 }, this.loadLists);
  };

  setLimit = (e) => {
    this.setState({ limit: Number(e.target.value), page: 1 }, this.loadLists);
  };

  goPage = (p) => {
    const page = Math.min(Math.max(1, p), this.state.totalpages);
    if (page === this.state.page) return;
    this.setState({ page: page }, () => {
      this.loadLists();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  };

  openList = (id) => { window.location.href = `/purchaseList?id=${id}`; };

  // نافذة أرقام حول الصفحة الحالية: ٢٠٠ صفحة لا تُعرض أزرارها كلها.
  pageNumbers() {
    const { page, totalpages } = this.state;
    const span = 2;
    const out = [];
    const push = (v) => { if (out[out.length - 1] !== v) out.push(v); };

    push(1);
    if (page - span > 2) push('…');
    for (let i = Math.max(2, page - span); i <= Math.min(totalpages - 1, page + span); i++) push(i);
    if (page + span < totalpages - 1) push('…');
    if (totalpages > 1) push(totalpages);

    return out;
  }

  renderPager() {
    const { page, totalpages, loading } = this.state;
    if (totalpages <= 1) return null;

    const atFirst = page === 1 || loading;
    const atLast = page === totalpages || loading;

    return (
      <div style={S.pager}>
        <button style={S.pBtn(atFirst)} disabled={atFirst}
          onClick={() => this.goPage(1)} title="الأولى">»</button>
        <button style={S.pBtn(atFirst)} disabled={atFirst}
          onClick={() => this.goPage(page - 1)}>السابق</button>

        {this.pageNumbers().map((n, i) => (
          n === '…'
            ? <span key={'d' + i} style={S.pDots}>…</span>
            : <button key={n} style={S.pNum(n === page)} disabled={n === page || loading}
              onClick={() => this.goPage(n)}>{n}</button>
        ))}

        <button style={S.pBtn(atLast)} disabled={atLast}
          onClick={() => this.goPage(page + 1)}>التالي</button>
        <button style={S.pBtn(atLast)} disabled={atLast}
          onClick={() => this.goPage(totalpages)} title="الأخيرة">«</button>
      </div>
    );
  }

  render() {
    const { lists, loading, page, limit, totalItems, status, q, qApplied, totals } = this.state;
    const filtered = !!qApplied || status !== 'all';

    const from = totalItems ? (page - 1) * limit + 1 : 0;
    const to = Math.min(page * limit, totalItems);

    return (
      <div style={{ ...S.page, ...S.pageInner }}>
        <ToastContainer rtl position="top-left" autoClose={4000} />

        <div style={S.head}>
          <h1 style={S.h1}>قوائم مشتريات الأجهزة</h1>
          <div style={S.sub}>اختر قائمة لعرض تفاصيلها وتدقيقها وتسعيرها</div>
        </div>

        {/* ملخّص عام — من الخادم على كل القوائم المطابقة، لا على الصفحة */}
        <div style={S.statsRow}>
          <div style={S.stat("#0f172a")}>
            <div style={S.statLabel}>عدد القوائم</div>
            <div style={S.statValue()}>{totals.lists}</div>
            <div style={S.statHint}>{totals.open} مفتوحة · {totals.closed} مقفلة</div>
          </div>
          <div style={S.stat("#2563eb")}>
            <div style={S.statLabel}>إجمالي الأجهزة</div>
            <div style={S.statValue("#2563eb")}>{totals.devices}</div>
            <div style={S.statHint}>{filtered ? "ضمن نتيجة الفلترة" : "في كل القوائم"}</div>
          </div>
          <div style={S.stat("#dc2626")}>
            <div style={S.statLabel}>بانتظار التدقيق</div>
            <div style={S.statValue("#dc2626")}>{totals.pending}</div>
            <div style={S.statHint}>مجمّدة عن العمل</div>
          </div>
          <div style={S.stat("#d97706")}>
            <div style={S.statLabel}>بلا سعر</div>
            <div style={S.statValue("#d97706")}>{totals.unpriced}</div>
            <div style={S.statHint}>تنتظر التسعير</div>
          </div>
        </div>

        {/* شريط البحث والفلترة */}
        <div style={S.toolbar}>
          <div style={S.searchWrap}>
            <span style={S.searchIcon}>🔎</span>
            <input
              style={S.searchInput}
              value={q}
              onChange={this.onSearchChange}
              onKeyDown={this.onSearchKey}
              placeholder="رقم القائمة · التاجر · الملاحظات · التاريخ — أو سيريال/IMEI/ماك/باركود جهاز"
            />
            {q ? <button style={S.clearBtn} onClick={this.clearSearch} title="مسح">✕</button> : null}
          </div>

          <div style={S.tabs}>
            <button style={S.tab(status === 'all')} onClick={() => this.setStatus('all')}>الكل</button>
            <button style={S.tab(status === 'open')} onClick={() => this.setStatus('open')}>مفتوحة</button>
            <button style={S.tab(status === 'closed')} onClick={() => this.setStatus('closed')}>مقفلة</button>
          </div>

          <select style={S.select} value={limit} onChange={this.setLimit}>
            {LIMITS.map(n => <option key={n} value={n}>{n} في الصفحة</option>)}
          </select>
        </div>

        <div style={S.resultLine}>
          {loading ? "جارٍ التحميل…"
            : totalItems
              ? <span>عرض <b style={{ color: "#0f172a" }}>{from}–{to}</b> من <b style={{ color: "#0f172a" }}>{totalItems}</b> قائمة</span>
              : null}
          {qApplied ? <span style={S.badge("#eff6ff", "#1d4ed8")}>بحث: {qApplied}</span> : null}
        </div>

        {loading ? (
          <div style={S.empty}>جارٍ التحميل…</div>
        ) : !lists.length ? (
          <div style={S.empty}>
            {filtered ? "لا توجد قائمة تطابق البحث" : "لا توجد قوائم بعد"}
          </div>
        ) : (
          <div style={S.grid}>
            {lists.map(l => {
              const total = Number(l.deviceCount) || 0;
              const verified = Number(l.verified_count) || 0;
              const pending = Number(l.pending_count) || 0;
              const rejected = Number(l.rejected_count) || 0;
              const matched = Number(l.matched_devices) || 0;
              const pct = total ? Math.round((verified / total) * 100) : 0;
              const done = total > 0 && pending === 0;
              const stripe = l.is_closed ? "#94a3b8" : done ? "#16a34a" : "#dc2626";

              return (
                <div key={l.id} style={S.card(!l.is_closed)}
                  onClick={() => this.openList(l.id)}
                  onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,.09)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,.06)"; }}>
                  <div style={S.cardStripe(stripe)} />

                  <div style={S.cardTop}>
                    <span style={S.cardTitle}>قائمة #{l.id}</span>
                    <span style={l.is_closed ? S.badge("#f1f5f9", "#64748b") : S.badge("#dcfce7", "#16a34a")}>
                      {l.is_closed ? "مقفلة" : "مفتوحة"}
                    </span>
                  </div>

                  {l.merchant_name ? (
                    <div style={S.merchant} title={l.merchant_name}>
                      <span style={S.merchantIcon}>التاجر:</span>
                      {l.merchant_name}
                    </div>
                  ) : null}

                  <div style={S.metaRow}>
                    <div>
                      <div style={S.meta}>الأجهزة</div>
                      <div style={S.metaVal}>{total}</div>
                    </div>
                    <div>
                      <div style={S.meta}>التاريخ</div>
                      <div style={{ ...S.metaVal, fontSize: 13.5, fontWeight: 600 }}>
                        {moment(l.createdAt).format("YYYY-MM-DD")}
                      </div>
                    </div>
                  </div>

                  {/* تقدّم التدقيق */}
                  <div style={{ fontSize: 12.5, color: "#64748b", marginBottom: 6 }}>
                    التدقيق: <b style={{ color: done ? "#16a34a" : "#0f172a" }}>{verified}</b> / {total}
                    <span style={{ float: "left", fontWeight: 700, color: done ? "#16a34a" : "#64748b" }}>{pct}%</span>
                  </div>
                  <div style={S.bar}>
                    <div style={S.barFill(pct, done ? "#16a34a" : "#2563eb")} />
                  </div>

                  <div style={S.flags}>
                    {/* شارة سبب الظهور في البحث: القائمة قد لا يطابق رقمها
                        ما كُتب، وإنما طابقه جهاز بداخلها. */}
                    {matched > 0 ? (
                      <span style={S.badge("#eff6ff", "#1d4ed8")}>🔎 مطابق: {matched} جهاز</span>
                    ) : null}
                    {pending > 0 ? (
                      <span style={S.badge("#fee2e2", "#991b1b")}>متبقٍ مسح: {pending}</span>
                    ) : total > 0 ? (
                      <span style={S.badge("#dcfce7", "#16a34a")}>✅ مكتمل التدقيق</span>
                    ) : null}
                    {l.unpriced_count > 0 ? (
                      <span style={S.badge("#fffbeb", "#92400e")}>بلا سعر: {l.unpriced_count}</span>
                    ) : null}
                    {rejected > 0 ? (
                      <span style={S.badge("#f1f5f9", "#64748b")}>مرفوض: {rejected}</span>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {this.renderPager()}
      </div>
    );
  }
}
